import { InjectionToken } from '@angular/core';
/** Registers a statically loaded component */
export class ComponentNameAndType {
    name;
    type;
    canActivate;
    resolve;
}
/**
 * @param {unknown} object
 */
export function instanceOfComponentNameAndType(object) {
    return typeof object === 'object' && object !== null && 'type' in object;
}
/**
 * @param {unknown} object
 */
export function instanceOfComponentNameAndModule(object) {
    return typeof object === 'object' && object !== null && 'module' in object;
}
export const PLACEHOLDER_COMPONENTS = new InjectionToken('Sc.placeholder.components');
export const PLACEHOLDER_LAZY_COMPONENTS = new InjectionToken('Sc.placeholder.lazyComponents');
export const PLACEHOLDER_MISSING_COMPONENT_COMPONENT = new InjectionToken('Sc.placeholder.missingComponentComponent');
export const PLACEHOLDER_HIDDEN_RENDERING_COMPONENT = new InjectionToken('Sc.placeholder.hiddenRenderingComponent');
export const DYNAMIC_COMPONENT = new InjectionToken('Sc.placeholder.dynamicComponent');
export const GUARD_RESOLVER = new InjectionToken('Sc.placeholder.guardResolver');
export const DATA_RESOLVER = new InjectionToken('Sc.placeholder.dataResolver');
